module.exports = __webpack_public_path__ + "img/full1-min.b9b2c2de.png";